module.exports = __webpack_public_path__ + "static/media/Rosana_Pianilino_Sagrado_Feminino.7b944e8e.jpg";